function ImpactHero() {
    React.useEffect(() => {
        let cleanup = null;
        let isMounted = true;
        async function initVoxels() {
            try {
                const { createVoxelGrid } = await import('../../utils/threeScene.js');
                // Example data for hero visualization
                const heroData = [
                    { value: 2, label: 'E-waste', color: '#10B981' },
                    { value: 5, label: 'Students', color: '#3B82F6' },
                    { value: 15, label: 'Schools', color: '#F59E42' },
                    { value: 160, label: 'CO2', color: '#F43F5E' }
                ];
                if (isMounted) {
                    cleanup = await createVoxelGrid('hero-voxel-container', heroData, {
                        voxelSize: 0.7,
                        gridSize: 2,
                        heightScale: 8,
                        spacing: 0.3,
                        colors: ['#10B981', '#3B82F6', '#F59E42', '#F43F5E'],
                        rotationSpeed: 0.002
                    });
                }
            } catch (error) {
                console.error('ImpactHero Three.js error:', error);
            }
        }
        initVoxels();
        return () => {
            isMounted = false;
            if (typeof cleanup === 'function') cleanup();
        };
    }, []);
    return (
        <div className="relative h-screen flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0">
                <img 
                    src="https://images.unsplash.com/photo-1554769945-af468c934022?crop=entropy&cs=srgb&fm=jpg&ixid=M3wzMjA0NjB8MHwxfHNlYXJjaHwyfHxncmVlbiUyMHRlY2h8ZW58MHx8fHwxNzQyOTcwNjU5fDA&ixlib=rb-4.0.3&q=85"
                    alt="Wind turbines"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 to-gray-900/90"></div>
            </div>
            <div className="container mx-auto px-4 relative z-10 text-center">
                <h1 className="text-6xl font-bold mb-6 text-white">
                    Making a <span className="text-green-400">Real Impact</span>
                </h1>
                <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-12">
                    Discover how we're transforming e-waste into educational opportunities while fighting climate change.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700">
                        <div className="text-3xl font-bold text-green-400 mb-2">2+</div>
                        <div className="text-gray-300">Tons of E-waste Diverted</div>
                    </div>
                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700">
                        <div className="text-3xl font-bold text-green-400 mb-2">5k+</div>
                        <div className="text-gray-300">Students Impacted</div>
                    </div>
                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700">
                        <div className="text-3xl font-bold text-green-400 mb-2">15</div>
                        <div className="text-gray-300">Schools Supported</div>
                    </div>
                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700">
                        <div className="text-3xl font-bold text-green-400 mb-2">160+</div>
                        <div className="text-gray-300">Kg CO₂ Saved</div>
                    </div>
                </div>
            </div>
            {/* 3D Voxel Container */}
            <div 
                id="hero-voxel-container" 
                className="absolute inset-0 z-0 pointer-events-none"
                aria-hidden="true"
            ></div>
            <div className="absolute bottom-0 left-0 w-full h-24">
                <svg className="w-full h-full" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-gray-900"></path>
                </svg>
            </div>
        </div>
    );
}

window.ImpactHero = ImpactHero;
export default ImpactHero;
